/*!
 * ListView - Vue liste horizontale compacte pour IconsView
 */

import CardView from './CardView';

export default class ListView extends CardView {
    constructor(plugin) {
        super(plugin, 'list');
    }

    renderIcon(data, container, subdir, path) {
        const myself = this.plugin;
        if (data.type === 'root') return true;

        myself.viewItemThumbsMode = false;
        const currentViewConf = myself.getViewConfig('list') || {};
        const currentIconSize = myself.getViewIconSize('list');

        myself.viewThumbsHeight = currentIconSize;
        myself.viewThumbsWidth = currentIconSize;
        myself.viewItemWidthRatio = currentViewConf.ratio || 5;
        myself.viewItemWidthMin = currentViewConf.minWidth || 200;
        myself.viewItemWidthMax = currentViewConf.maxWidth || 400;

        const currentType = this.getTypes(data);
        const currentClassAll = this.buildItemClasses(data, currentType, (data.class || data.cls || ''));

        const listFields = myself.getViewFields('list') || myself.getViewFields('mosaic');
        const codeSubtext = this.buildFieldsSubtext(data, listFields);

        let countHtml = '';
        if (myself.shouldShowCount(data, 'list')) {
            countHtml = ' <span class="iv__item__count">(' + data.count + ')</span>';
        }

        let customItemStyle = '';
        if (currentViewConf.width || currentViewConf.size) {
            const w = currentViewConf.width || currentViewConf.size;
            customItemStyle = 'style="width:' + (typeof w === 'number' ? w + 'px' : w) + ';"';
        }

        const code = '<div class="' + currentClassAll + '" ' + customItemStyle + '><div class="iv__item__frame"><span class="iv__item__link"><span class="iv__item__image">' + myself.renderIconImage(myself.viewThumbsWidth, data.icon, data, 'img') + '</span> '
                + '<label class="iv__item__label">'
                + '<span class="iv__item__name titre">' + data.label + '</span>'
                + countHtml
                + ((codeSubtext.length > 0) ? '<span class="iv__item__data infos">' + codeSubtext.join('') + '</span>' : '')
                + '</label></span></div></div>';

        const currentIcon = $(code);
        container.append(currentIcon);
        this.attachItemEvents(currentIcon, currentIcon, data, currentType, path);
        this.renderBadge(data, currentIcon);

        return currentIcon;
    }

    resize() {
        const myself = this.plugin;
        const currentViewConf = myself.getViewConfig('list') || {};
        const canvaWidth = myself.element.find('.view').width();
        if (!canvaWidth) return;

        if (currentViewConf.cols || currentViewConf.columns) {
            const cols = parseInt(currentViewConf.cols || currentViewConf.columns, 10);
            const gap = currentViewConf.gap !== undefined ? currentViewConf.gap : 12;
            const computedWidth = Math.floor((canvaWidth - (gap * (cols - 1))) / cols);
            myself.element.find('.iv__item').not('.iv__tabs__btn, .iv__breadcrumb__item').css('width', computedWidth);
            return;
        }

        if (currentViewConf.width || currentViewConf.size) {
            const targetWidth = parseInt(currentViewConf.width || currentViewConf.size, 10);
            const gap = currentViewConf.gap !== undefined ? currentViewConf.gap : 12;
            const colCount = canvaWidth / (targetWidth + gap);
            const colCountFix = Math.max(1, Math.ceil(colCount));
            const adjustedWidth = Math.floor((canvaWidth / colCountFix) - gap);
            myself.element.find('.iv__item').not('.iv__tabs__btn, .iv__breadcrumb__item').css('width', adjustedWidth);
        }
    }

    getZoomLimits() {
        return { enabled: true, min: 16, max: 64 };
    }
}
